import type { FunctionComponent, ReactElement } from 'react';
import { useCallback } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { useAutoplaySlice } from '../../../store/slices/autoplay/selectors';
import { useBetSlice } from '../../../store/slices/bets/selectors';
import { toastActions } from '../../../store/slices/toast/slice';
import { Toast } from '../../toast/Toast';
import type { ToastConnectedProps } from '../types';

export const AutoplayNotChangedToastConnected: FunctionComponent<ToastConnectedProps> = ({
  timeStamp,
  ...rest
}): ReactElement => {
  const dispatch = useCoreDispatch();

  const savedBet = useAutoplaySlice.getSavedBet();
  const disabledBetSpots = useBetSlice.getDisabledBetSpots();

  const savedBetSpots = Object.keys(savedBet?.betSpots || {}).filter(
    (el) => (savedBet?.betSpots?.[el]?.value || 0) > 0
  );
  const someBetsUnavailable = savedBetSpots.some((r) => disabledBetSpots.includes(r));

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  const text = someBetsUnavailable ? 'TOAST_SPREAD_BETS_DISABLED' : 'AUTOPLAY_CONTINUED_NO_CHANGES';

  return <Toast onClose={closeFn} {...rest} message={text} />;
};
